var collectionLanding = localStorage.getItem("collection_path");
if(collectionLanding == null) {
  collectionLanding = localStorage.setItem("collection_path","");
}
if(document.body.classList.contains("on-collection")) {
  var collection_url = window.location.href;
  var collection_title = document.querySelector("#collection_info_for_breadcrumbs").getAttribute("data-title");
  console.log(collection_url);
  console.log(collection_title);
  collectionLanding = localStorage.setItem("collection_path",`${collection_url}++${collection_title}`);
}
else if(document.body.classList.contains("on-product")) {
  var collectionLanding = localStorage.getItem("collection_path");
  console.log(collectionLanding);
  if(collectionLanding != '') {
    var potential_user_url = collectionLanding.split("++")[0];
    var potential_user_title = collectionLanding.split("++")[1];
    document.querySelector(".potential_user_url").setAttribute("href",potential_user_url);
    document.querySelector(".potential_user_url").setAttribute("title",potential_user_title);
    document.querySelector(".potential_user_title").innerHTML = potential_user_title;
  }
  else {
    document.querySelector(".potential_user_title").innerHTML = document.querySelector(".potential_user_url").getAttribute("title");
  }
}
else {
  collectionLanding = localStorage.setItem("collection_path","");
}